<template>
  <div id="roundtable">
    <v-card
      class="mx-auto my-3"
      color="#e6e6fa"
    >
      <v-simple-table>
        <template v-slot:default class="user-table-inner">
          <thead>
            <tr>
              <th class="text-center header-name">ラウンド</th>
              <th class="text-center header-round">1</th>
              <th class="text-center header-round">2</th>
              <th class="text-center header-round">3</th>
              <th class="text-center header-round">4</th>
              <th class="text-center header-round">5</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>ミッション結果</td>
              <td v-for="n in 5" v-bind:key="n">
                <span v-if="results[n-1]=='success'" v-on:click="showExecuter(n)" class="mission-result">
                  <u>o</u>
                </span>
                <span v-else-if="results[n-1]=='fail'" v-on:click="showExecuter(n)" class="mission-result">
                  <u>x</u>
                </span>
                <div v-else-if="(n-1)==round && role && (winner!='resistance'&&winner!='spy')"><span style=""><b>NOW</b></span></div>
                <div v-else>-</div>
              </td>
            </tr>
            <tr>
              <td>
              <span v-on:click="showDescription" class="required-num-description">
                <b><u>必要人数</u></b>
              </span></td>
              <td v-for="(value, key) in requiredNum" v-bind:key="key">
                {{ value }}
                <span v-show="requiredFail[key]>1" v-on:click="showDescriptionFourthRound" class="caution"><u>※</u></span>
              </td>
            </tr>
            <tr>
              <td class="vote-column">
              <span>
                投票結果
              </span></td>
              <td v-for="i in 5" v-bind:key="i*10" class="vote-column">
                <span v-if="0<votes[i-1].votes.length" v-on:click="showVotes({'round':i,'revote':0})" class="vote-result">
                  <b><u>1回目</u></b>
                </span>
                <span v-else-if="0==votes[i-1].votes.length && voting && round==i-1" ><b>NOW</b></span>
                <span v-else>-</span>
              </td>
            </tr>

            <tr v-if="voteRowLength>1||(voting&&votes[round].votes.length>0)">
              <td class="vote-column"></td>
              <td v-for="j in 5" v-bind:key="j*10+1" class="vote-column">
                <span v-if="1<votes[j-1].votes.length" v-on:click="showVotes({'round':j,'revote':1})" class="vote-result">
                  <b><u>2回目</u></b>
                </span>
                <span v-else-if="1==votes[j-1].votes.length && voting && round==j-1"><b>NOW</b></span>
                <span v-else>-</span>
              </td>
            </tr>

            <tr v-if="voteRowLength>2||(voting&&votes[round].votes.length>1)">
              <td class="vote-column"></td>
              <td v-for="j in 5" v-bind:key="j*10+2" class="vote-column">
                <span v-if="2<votes[j-1].votes.length" v-on:click="showVotes({'round':j,'revote':2})" class="vote-result">
                  <b><u>3回目</u></b>
                </span>
                <span v-else-if="2==votes[j-1].votes.length && voting && round==j-1" ><b>NOW</b></span>
                <span v-else>-</span>
              </td>
            </tr>

            <tr v-if="voteRowLength>3||(voting&&votes[round].votes.length>2)">
              <td class="vote-column"></td>
              <td v-for="j in 5" v-bind:key="j*10+3" class="vote-column">
                <span v-if="3<votes[j-1].votes.length" v-on:click="showVotes({'round':j,'revote':3})" class="vote-result">
                  <b><u>4回目</u></b>
                </span>
                <span v-else-if="3==votes[j-1].votes.length && voting && round==j-1" ><b>NOW</b></span>
                <span v-else>-</span>
              </td>
            </tr>

            <tr v-if="voteRowLength>4||(voting&&votes[round].votes.length>3)">
              <td class="vote-column"></td>
              <td v-for="j in 5" v-bind:key="j*10+4" class="vote-column">
                <span v-if="4<votes[j-1].votes.length" v-on:click="showVotes({'round':j,'revote':4})" class="vote-result">
                  <b><u>5回目</u></b>
                </span>
                <span v-else-if="4==votes[j-1].votes.length && voting && round==j-1" ><b>NOW</b></span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- <v-simple-table class="vote-result-table">
        <template>
          <tbody>
            <tr>
              <td class="vote-row vote-row-left">
              <span>
                投票結果
              </span></td>
              <td v-for="i in 4" v-bind:key="i" class="vote-row">
                <span v-if="i-1<votes.length" v-on:click="showVotes(i)" class="vote-result">
                  <b><u>{{ i }}回目</u></b>
                </span>
                <span v-else-if="i-1==votes.length">NOW</span>
                <span v-else>-</span>
              </td>
              <td class="vote-row vote-row-right">
                <span v-if="4<votes.length" v-on:click="showVotes(5)" class="vote-result">
                  <b><u>5回目</u></b>
                </span>
                <span v-else-if="4==votes.length">NOW</span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table> -->

      <!-- <p>[DEBUB]results:{{results}}, current:{{round}}</p> -->
      <!-- <tr v-for="(value, key) in users" v-bind:key="key">
        <td>{{ value.userName }}</td>
        <td v-if="value.isLeader">o</td>
        <td v-else>-</td>
      </tr> -->
    </v-card>
    <!-- <v-row justify="center"> -->
    <v-dialog v-model="missionDialog" scrollable max-width="300px">
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template> -->
      <v-card
        class="mission-result-dialog"
        max-width="400"
        color="#DDDDFF"
      >
        <p style="margin-top:12px;color:#444499"><b>ミッション結果[{{ missionResultIndex+1 }}回目]</b></p>
        <v-divider></v-divider>
        <div class="vote-table">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="background-color:#222288;color:#FFFFFF">内訳</td>
                </tr>
                <tr>
                  <td style="color:#222288">完遂: {{ missionCards[missionResultIndex].success }}</td>
                  <!-- <td>{{ missionCards[missionResultIndex].success }}</td> -->
                </tr>
                <tr>
                  <td style="color:#C71585">妨害: {{ missionCards[missionResultIndex].fail }}</td>
                  <!-- <td>{{ missionCards[missionResultIndex].fail }}</td> -->
                </tr>
                <tr>
                  <td style="background-color:#222288;color:#FFFFFF">ミッションメンバー</td>
                </tr>
                <tr v-for="user in missionExecuters[missionResultIndex]" :key="user.name">
                  <td>{{ user.name }}</td>
                </tr>
            <!-- </li>
            <li v-for="vote in votes" :key="vote.name">
              {{ vote.name }}: {{vote.vote}}
            </li> -->
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
            <v-col class="text-right" >
              <v-btn color="blue darken-1" text @click="missionDialog = false"><b><u>CLOSE</u></b></v-btn>
            </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="voteDialog" scrollable max-width="300px">
      <v-card
        class="vote-result-dialog"
        max-width="400"
        color="#DDDDFF"
      >
        <p style="margin-top:12px;color:#444499"><b>投票結果(ラウンド{{ voteResultIndex.round+1 }}: {{ voteResultIndex.revote+1 }}回目)</b></p>
        <v-divider></v-divider>
        <div class="vote-table">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <!-- <tr v-for="prevote in prevotes" :key="prevote.name">
                  <td>{{ prevote.name }}</td>
                  <td v-if="prevote.vote=='agree'">承認（総意の形成者）</td>
                  <td v-else>否認（総意の形成者）</td>
                </tr> -->
                <tr v-for="vote in votes[voteResultIndex.round].votes[voteResultIndex.revote]" :key="vote.name">
                  <td v-if="vote.prevote">{{ vote.name }}(総意の形成者)</td>
                  <td v-else>{{ vote.name }}</td>
                  <td v-if="vote.vote=='agree'" style="color:#222288">承認</td>
                  <td v-else style="color:#C71585">否認</td>
                </tr>
            <!-- </li>
            <li v-for="vote in votes" :key="vote.name">
              {{ vote.name }}: {{vote.vote}}
            </li> -->
              </tbody>
            </template>
          </v-simple-table>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td style="background-color:#222288;color:#FFFFFF">リーダー</td>
                </tr>
                <tr>
                  <td>{{ votes[voteResultIndex.round].leader[voteResultIndex.revote].name }}</td>
                </tr>
                <tr>
                  <td style="background-color:#222288;color:#FFFFFF">ミッションメンバー</td>
                </tr>
                <tr v-for="user in votes[voteResultIndex.round].assigned[voteResultIndex.revote]" :key="user.name+'assigned'">
                  <td>{{ user.name }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn color="blue darken-1" text @click="voteDialog = false"><b><u>CLOSE</u></b></v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <!-- </v-row> -->
  </div>

</template>
<script>
export default {
  data () {
    return {
      missionDialog : false,
      missionResultIndex : 0,
      voteDialog : false,
      voteResultIndex : {round:0, revote:0}
      // round : this.$store.getters.round,
      // results : this.$store.getters.result
      // role : this.$store.state.userInfo.role
    }
  },
  computed: {
    role : function () {
      return this.$store.state.userInfo.role
    },
    round : function () {
      return this.$store.state.missionInfo.round
    },
    results : function () {
      return this.$store.state.missionInfo.result
    },
    requiredNum: function() {
      return this.$store.state.missionInfo.requiredNums
    },
    requiredFail: function() {
      return this.$store.state.missionInfo.requiredFails
    },
    votes: function() {
      return this.$store.state.missionInfo.votes
    },
    voteRowLength: function() {
      return Math.max.apply(null, this.votes.map(function(v){return v.votes.length}))
    },
    voting() {
      return this.$store.state.missionInfo.voting
    },
    missionCards: function() {
      return this.$store.state.missionInfo.missionCards
    },
    missionExecuters: function() {
      return this.$store.state.missionInfo.missionExecuters
    },
    winner: function() {
      return this.$store.state.missionInfo.winner
    }
  },
  methods: {
    showDescription: function() {
      var modalContent = {title: "必要人数について", text: "ラウンド毎にミッションの参加人数は異なる．"}
      this.$emit('show-modal', modalContent)
    },
    showDescriptionFourthRound: function() {
      var modalContent = {title: "必要人数について", text: "このラウンドのみ２人以上がミッションを妨害した場合に失敗する．"}
      this.$emit('show-modal', modalContent)
    },
    showExecuter: function(n) {
      console.log(this.missionCards)
      this.missionResultIndex = n-1
      this.missionDialog=true
      // var modalContent = {title: "ミッションメンバー[ラウンド", text: ""}
      // modalContent.title += String(n) + "]"
      // for (var i in this.missionExecuters[n-1]){
      //   modalContent.text += this.missionExecuters[n-1][i].name + "\n"
      // }
      // this.$emit('show-modal', modalContent)
    },
    showVotes(index) {
      console.log(index)
      this.voteResultIndex.round = index.round - 1
      this.voteResultIndex.revote = index.revote
      this.voteDialog=true
      // var modalContent = {title: "投票 ", text: ""}
      // modalContent.title += String(n) + "回目"
      // for (var i in this.votes[n-1]){
      //   modalContent.text += this.votes[n-1][i].name + ": " + this.votes[n-1][i].vote + "\n"
      // }
      // this.$emit('show-modal', modalContent)
    }
  },
  created() {
    this.$store.commit('clearVotes')
    console.log(this.votes)
  }
}
</script>
<style>
#roundtable table {
  /* border-collapse: collapse; */
}
#roundtable th{
  font-size: 16px;
  border-bottom-width: 2px;
  border-color: black;
  color: white;
  background-color: #222288
}

#roundtable .header-name {
  min-width: 150px
}
#roundtable .header-round {
  min-width: 80px
}
#roundtable .vote-column {
  background-color: #e6e6ea
}

#roundtable .vote-row {
  border-top:4px solid #222288;
  border-bottom:4px solid #222288;
}
#roundtable .vote-row-left {
  border-left:4px solid #222288;
}
#roundtable .vote-row-right {
  border-right:4px solid #222288;
}
#roundtable td {
  font-size: 16px;
  border-bottom-width: 0px;
  border-color: black;
  background-color: #F5F5F5
}

#roundtable .required-num-description {
  color: #5555BB;
  cursor:pointer ;
}
#roundtable .caution {
  color: #5555BB;
  cursor:pointer ;
}
#roundtable .vote-result {
  /* font-size: 24px; */
  color: #5555BB;
  cursor:pointer;
}
#roundtable .mission-result {
  font-size: 24px;
  color: #5555BB;
  cursor:pointer;
}

#roundtable .vote-result-table {
  margin-top: 12px
}

#round .vote-result-dialog {
  padding-top: 30px;
  padding-bottom: 30px
}
</style>
